export const QUEUE_ID_PARAM_KEY = 'queueId';

export const queueSettingsRoute = () =>
  `/queues/:${QUEUE_ID_PARAM_KEY}/settings` as const;
